import React, { useState } from "react"

import InvoicePaymentModal from "~/components/payments/InvoicePaymentModal"
import ManualPaymentModal from "~/components/payments/ManualPaymentModal"
import SavedCardChargeModal from "~/components/payments/SavedCardChargeModal"

import type PaymentItem from "~/types/PaymentItem"
import type SavedPaymentMethod from "~/types/SavedPaymentMethod"
import type { PayablePaymentResource } from "~/types/PayablePaymentResource"

export type PaymentKind = "Invoice" | "Manual" | "SavedCard"
export type PayablePaymentModalMode = "create" | "charge_saved_card"

interface PayablePaymentModalProps {
  onClose: () => void
  onSuccess: () => void | Promise<void>
  resource: PayablePaymentResource
  initialItems?: PaymentItem[]
  mode?: PayablePaymentModalMode
  savedPaymentMethod?: SavedPaymentMethod | null
  totalAmountCents?: number | null
  paidAmountCents?: number | null
  remainingAmountCents?: number | null
}

const PayablePaymentModal: React.FC<PayablePaymentModalProps> = ({
  onClose,
  onSuccess,
  resource,
  initialItems = [],
  mode = "create",
  savedPaymentMethod = null,
  totalAmountCents = null,
  paidAmountCents = null,
  remainingAmountCents = null,
}) => {
  const [paymentType, setPaymentType] = useState<PaymentKind>("Invoice")

  if (paymentType === "Manual") {
    return (
      <ManualPaymentModal
        onClose={onClose}
        onSuccess={onSuccess}
        resource={resource}
        initialItems={initialItems}
        showTypeSelector={true}
        paymentType={paymentType}
        onPaymentTypeChange={setPaymentType}
      />
    )
  }

  if (paymentType === "SavedCard") {
    return (
      <SavedCardChargeModal
        onClose={onClose}
        onSuccess={onSuccess}
        resource={resource}
        initialItems={initialItems}
        savedPaymentMethod={savedPaymentMethod}
        showTypeSelector={true}
        paymentType={paymentType}
        onPaymentTypeChange={setPaymentType}
        totalAmountCents={totalAmountCents}
        paidAmountCents={paidAmountCents}
        remainingAmountCents={remainingAmountCents}
      />
    )
  }

  return (
    <InvoicePaymentModal
      onClose={onClose}
      onSuccess={onSuccess}
      resource={resource}
      initialItems={initialItems}
      showTypeSelector={true}
      paymentType={paymentType}
      onPaymentTypeChange={setPaymentType}
    />
  )
}

export default PayablePaymentModal
